var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c(
        "el-checkbox-group",
        {
          model: {
            value: _vm.conformity,
            callback: function($$v) {
              _vm.conformity = $$v
            },
            expression: "conformity"
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "strictMode" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Bloquer la modification, la suppression ou l‘annulation d‘une facture ou d‘un avoir finalisé"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("el-checkbox", { attrs: { label: "forbidEditIdent" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Bloquer la modification du numéro des factures et des avoirs"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "CompassTooltip",
                { attrs: { disabled: !_vm.isDisabled("forbidEditDate") } },
                [
                  _c("template", { slot: "content" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$l10n.__(
                            "Vous ne pouvez pas bloquer la modification de la date car un ou plusieurs documents (factures ou avoirs) possèdent une date dans le futur."
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        label: "forbidEditDate",
                        disabled: _vm.isDisabled("forbidEditDate")
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$l10n.__(
                            "Bloquer la modification de la date des factures et des avoirs"
                          )
                        )
                      )
                    ]
                  )
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.save") },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.save($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }